import EntitySelection from './EntitySelection';

export default EntitySelection;
